import React from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../../AppContext.js";
import { DropDwnDown, DropDwnUp } from "../../gui_components/Icons.js";
import {
  AddressBean,
  AttributeCacheBean,
  PageListBean,
  RestEntityUnLockRequest,
  RestReadRequest,
  RestRoleListRequest,
  RoleBean,
  RoleEntitlementBean,
  RoleSearchCriteria,
} from "./../../ds/ds.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  ShowError,
} from "./../../gui_components/UIComponents.js";
import { BaseToolBar, ModuleToolBar } from "./../BaseModule.js";

import { NEW_ENTRY } from "../../ds/App_Constants.js";
import { SecurityAccessManager } from "../../security/SecurityAccessManager.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "./../../gui_components/Util.js";
import { RoleLookupHandler } from "./../../lookup/RoleLookupHandler.js";
import { SecurityService } from "./../../services/SecurityService.js";
class RoleMaintenance extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      isListFormOpen: true,
      response: {},
      pageTitle: "Role Maintenance",
      modeText: "",
      roleData: new RoleBean(),
      entitleData: new RoleEntitlementBean(),
      addressData: new AddressBean(),
      pageList: new PageListBean(),
      criteria: new RoleSearchCriteria(),
      currentPageNumber: 0,
      totalCount: 0,
      attributeCache: new AttributeCacheBean(),
      companyCode: "",

      isEntryFormOpen: false,
      isShowNodes: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],

      selectedNodeKey: "headerView",

      isShowModuleSearchContainer: false,
      roleLookupHandler: null,

      moduleKeyCode: NEW_ENTRY,
      isResetModule: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      disabled: false,
      isfetched: false,
      //  selectedEntitlementList: [],
      roleList: [],
      isShowForm: false,

      // allModuleList: [],
      // allDependency: [],
      // moduleGroups: [],
      // entitlements: [],
      // fetchEntitlements: [],
      // selectedModuleList: [],
      finalEntList: [],

      isShowRolePopup: false,
      moduleGroups: [],
      selectedModuleList: [],
      moduleList: [],
      allModuleList: [],
      allDependency: null,
      entitlements: [],
      moduleEntitlements: [],
      isShowEntitlement: false,
      allChecked: false,
      moduleSubGroupList: [],
      isShowModuleTable: false,
      selectedEntitlementList: [],
      isShowEntitlementPopup: false,
      selectedAllModuleList: [],
      fetchEntitlements: [],
      isShowFlag: false,
      moduleEntityData: null,
      headerEntitlementList: [],
      isShowAlertLvl3: false,
      isShowAlertLvl4: false,
      order: "asc",
      sortField: "",
      isViewMode: false,
      isResetView: true,
      moduleGroupData: null,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
    }
    this.setState({
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      this.editRole(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
    }
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let roleLookupHandler = new RoleLookupHandler(this.companyCode, "Role");
    this.setState({ roleLookupHandler: roleLookupHandler });
  };
  moduleCaption = "Role Maintenance";
  addNewEntry = () => {
    let roleData = new RoleBean();
    let pageTitle = this.moduleCaption + "-" + NEW_ENTRY;

    if (!isEmptyString(this.state.moduleKeyCode)) {
      roleData.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else roleData.code = NEW_ENTRY;
    this.setState({
      roleData: roleData,
      pageTitle: pageTitle,
    });
    this.state.roleData = roleData;
    this.openRoleMaintenanceEntryForm();
    this.readRoleModule();
  };
  openRoleMaintenanceEntryForm = () => {
    let roleData = this.state.roleData;
    this.setState({
      isListFormOpen: false,
      isEntryFormOpen: true,
      isShowSaveButton: true,

      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,

      isShowModuleSearchContainer: true,
      disabled: false,
      isResetView: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isListFormOpen: false,
        disabled: false,
        isDisabledFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        disabled: true,
        isDisabledFields: true,
        isResetView: false,
        isMaintenanceMode: false,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
  };
  moduleExit = () => {
    let roleData = this.state.roleData;
    if (roleData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unLockRole(roleData.code);
      } else {
        this.isLocked = false;
      }
      this.props.onModuleExit();
    }
  };
  closeRoleMaintenanceEntryForm = () => {
    let pageTitle = this.moduleCaption;
    let roleData = new RoleBean();
    this.setState({
      roleData: roleData,
      isListFormOpen: true,
      isEntryFormOpen: false,
      isShowSaveButton: false,
      isShowApproveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      moduleKeyCode: NEW_ENTRY,
      isShowModuleSearchContainer: false,
      disabled: false,
      isResetView: false,
      isViewMode: false,
      isDisabledFields: false,
      isSpecialViewMode: false,
      isMaintenanceMode: false,

      finalEntList: [],

      moduleGroups: [],
      selectedModuleList: [],
      moduleList: [],
      allModuleList: [],
      allDependency: null,
      entitlements: [],
      moduleEntitlements: [],
      isShowEntitlement: false,

      moduleSubGroupList: [],
      isShowModuleTable: false,
      selectedEntitlementList: [],
      selectedAllModuleList: [],
      fetchEntitlements: [],
      isShowFlag: false,
      moduleEntityData: null,
      headerEntitlementList: [],
    });
  };

  onChange = (e) => {
    let roleData = this.state.roleData;
    roleData[e.target.name] = e.target.value;
    this.setState({ roleData: roleData });
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });

      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = new Array();
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  editRole = (code) => {
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = code;
    // request.isLockRequired = true;
    // let isLockRequired = NEW_ENTRY === code ? false : true;
    // request.isLockRequired = isLockRequired;

    if (!this.state.isSpecialViewMode) {
      let isLockRequired = NEW_ENTRY === code ? false : true;
      request.isLockRequired = isLockRequired;
    } else {
      request.isLockRequired = false;
    }
    if (SecurityAccessManager.RoleMaintenanceView_IsAccessible) {
      SecurityService.initRoleModule(
        request,
        this.editRoleResponse,
        this.errorCallBack
      );
    }
  };
  editRoleResponse = (response) => {
    // console.log("response.. role", response);
    let errMsg = "";
    if (response.data != null) {
      if (response.data.lockResponse != null) {
        if (!isEmpty(response.data.lockResponse.errors)) {
          this.showErrorMessage(response.data.lockResponse);
          this.state.isViewMode = true;
        }
      }
      if (response.data.roleResponse != null) {
        if (response.data.roleResponse.errors != null) {
          response.data.roleResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
        if (response.data.roleResponse.role != null) {
          let roleData = response.data.roleResponse.role;
          let moduleKeyCode = roleData.code;
          let pageTitle = this.moduleCaption + " - EDIT";
          this.state.roleData = roleData;
          if (response.data.success) this.clearError();

          this.setState({
            roleData: roleData,
            isShowForm: true,
            pageTitle: pageTitle,
            moduleKeyCode: moduleKeyCode,
          });
          this.isLocked = true;
          this.openRoleMaintenanceEntryForm();
          this.readRoleModule();
        } else {
          this.addNewEntry();
        }
      }
      if (response.data.roleResponse != null) {
        if (errMsg != "Role [" + this.state.moduleKeyCode + "] Not read!") {
          this.showErrorMessage(response.data.roleResponse);
        }
      }
    }
    // if (response.data != null && response.data.roleResponse != null) {
    //   let roleData = response.data.roleResponse.role;
    //   let pageTitle = this.moduleCaption + " - EDIT";

    //   if (roleData !== null) {
    //     let moduleKeyCode = roleData.code;
    //     this.state.roleData = roleData;
    //     this.setState({
    //       roleData: roleData,
    //       pageTitle: pageTitle,

    //       moduleKeyCode: moduleKeyCode,
    //       isShowForm: true,
    //     });
    //     this.openRoleMaintenanceEntryForm();
    //   } else {
    //     this.addNewEntry();
    //   }
    // }
  };
  editRoleError = (error) => {
    ShowError("Error :", error);
  };

  saveRoleResponse = (response) => {
    // console.log("role save response", response);
    this.handleResponse(response.data);
    if (
      response.data != null &&
      response.data.role != null &&
      !isEmpty(response.data.role)
    ) {
      let role = response.data.role;
      this.setState({ roleData: role });
      if (!this.isLocked) {
        this.editRole(role.code);
      } else {
        this.code = role.code;
        this.unLockRole(response.data.role.code);
      }
    }
  };
  saveError = (error) => {
    ShowError("Error.", error);
  };

  saveRole = () => {
    let roleData = this.state.roleData;
    roleData.companyCode = this.companyCode;
    console.log("role saveData : ", roleData);
    if (roleData.isFetched) {
      if (SecurityAccessManager.RoleMaintenanceEdit_IsAccessible()) {
        SecurityService.updateRole(
          roleData,
          this.saveRoleResponse,
          this.saveRoleError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.RoleMaintenanceCreate_IsAccessible()) {
        SecurityService.createRole(
          roleData,
          this.saveRoleResponse,
          this.saveRoleError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  validateRoleData = (data) => {
    // console.log("Validating role data: ", data);
    let isValid = false;
    let errMsg = "";
    let errList = [];
    if (isEmpty(data)) {
      errMsg = "Role Data Required";
      errList.push(errMsg);
    } else {
      if (isEmpty(data.roleEntitlements)) {
        errMsg = "Role Entitlements Required";
        errList.push(errMsg);
      }
    }

    if (errList.length > 0) {
      isValid = false;
      this.setState({
        isShowAlert: true,
        alertMessage: errList,
        alertType: "danger",
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  save = () => {
    let isValid = false;
    isValid = this.validateRoleData(this.state.roleData);
    if (isValid) {
      this.saveRole();
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  hideAlertCallBackLvl3 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl3: isDisplayed, error_list: [] });
  };
  hideAlertCallBackLvl4 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl4: isDisplayed, error_list: [] });
  };

  clearError = () => {
    this.setState({ error_list: [] });
  };
  getModuleListView = () => {
    let roleData = this.state.roleData;
    if (roleData.code === NEW_ENTRY) {
      this.closeRoleMaintenanceEntryForm();
      this.loadRolePage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unLockRole(roleData.code);
      } else {
        this.isLocked = false;
      }
      this.closeRoleMaintenanceEntryForm();
      this.loadRolePage();
    }
    this.clearError();
    // this.hideAlertCallBack();
  };
  loadRolePage = () => {
    let requestInput = new RestRoleListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.RoleMaintenanceView_IsAccessible()) {
      SecurityService.getRolePageList(
        requestInput,
        this.loadRolePageResponse,
        this.loadRolePageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadRolePageResponse = (response) => {
    let roleList = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.rolePageList) &&
      !isEmptyArray(response.data.rolePageList.roles)
    ) {
      roleList = response.data.rolePageList.roles;
      this.state.pageList.totalCount = response.data.rolePageList.totalCount;
      this.state.pageList.currentPage = response.data.rolePageList.currentPage;
    } else {
      roleList = new Array();
    }
    let loading = this.state.isLoading;
    loading = false;

    this.setState({
      isLoading: loading,
      roleList: roleList,
    });
  };
  loadRolePageError = (error) => {
    ShowError("Error :", error);
  };

  unLockRole = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.RoleMaintenance_IsAccessible()) {
      SecurityService.unLockRoleCode(
        request,
        this.unlockRoleResponse,
        this.unlockRoleError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  unlockRoleResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editRole(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        this.isLocked = false;
        // if (!this.state.isReseted)
        this.showErrorMessage(response.data);
      }
    }
  };
  unlockRoleError = (error) => {
    ShowError("Error : ", error);
  };

  onCriteriaChange = (e) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria["roleCode"] = e.target.value;

    this.setState({ criteria: criteria });
  };

  filterRole = () => {
    this.loadPage(1);
  };

  resetFilteredRole = (criteria) => {
    criteria = new RoleSearchCriteria();
    criteria.companyCode = this.companyCode;
    // criteria.speacialSearchText = "";
    this.state.criteria = criteria;

    this.setState({ criteria: criteria });
    this.loadPage(1);
  };

  loadFirst = () => {
    this.loadPage(1);
  };

  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };

  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    //totalPages = totalPages.toFixed(1);
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;

    this.loadRolePage();
  };

  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };

  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
    // let roleData = this.state.roleData;
    // this.unLockRole(roleData.code);
  };
  selectButtonClick = (e) => {
    if (!this.isLocked) {
      this.editRole(this.state.moduleKeyCode);
    }
    // let moduleKeyCode = this.state.moduleKeyCode;

    // let roleList = this.state.roleList.filter((rl) => rl.code == moduleKeyCode);

    // let roleObject = null;
    // if (roleList !== null) {
    //   roleObject = roleList[0];
    // }

    // if (roleObject != null) {
    //   this.setState({ isLockRequired: true });
    //   this.editRole(this.state.moduleKeyCode);
    // } else {
    //   this.addNewEntry(this.state.moduleKeyCode);
    // }

    // this.setState({
    //   isFocusLookup: false,
    // });
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  errorCallBack = (error) => {
    ShowError(error);
  };

  editRoleCheck = () => {
    let roleData = this.state.roleData;
    let entitlements = this.state.entitlements;
    let allModuleList = this.state.allModuleList;
    let moduleGroups = this.state.moduleGroups;

    // console.log("edit role check moduleGroups :", moduleGroups);
    //let test = [];
    let fetchEntitlements = [];
    if (roleData.roleEntitlements != null) {
      roleData.roleEntitlements.map((list) => {
        entitlements.map((ent) => {
          if (ent.code === list.entitlementCode) {
            ent.isActive = true;
            ent.isFetched = list.isFetched;
            // } else {
            //   ent.isActive = false;
            // }
            fetchEntitlements.push(ent);
          }
        });
      });
      let lastModuleList = [];
      fetchEntitlements.map((list) => {
        allModuleList.map((ml) => {
          if (ml.code === list.moduleEntityCode) {
            ml.isActive = true;

            lastModuleList.push(ml);
          }
        });
      });
      let lastModuleGroups = [];
      moduleGroups.map((mg) => {
        lastModuleList.map((ml) => {
          //if (ml.isActive === true) {
          if (mg.code === ml.moduleGroupCode) {
            mg.isActive = true;
            lastModuleGroups.push(mg);
          }
          // }
        });
      });
      if (roleData.isFetched) {
        this.setState({
          moduleGroups: moduleGroups,
        });
      }
      // console.log("role modulegroups..", moduleGroups);
      this.setState({
        fetchEntitlements: fetchEntitlements,
        selectedModuleList: lastModuleList,
      });
    }
  };
  readRoleModule = () => {
    let request = new RestReadRequest();
    request.code = this.state.roleData.code;

    // console.log("read role request:", request);
    SecurityService.readRoleModuleDependencies(
      request,
      this.readResponse,
      this.errorCallBack
    );
  };
  readResponse = (response) => {
    // console.log("read role response:", response);
    if (response.data != null) {
      if (
        response.data.dependenciesBean != null &&
        !isEmpty(response.data.dependenciesBean.moduleEntities) &&
        !isEmpty(response.data.dependenciesBean.moduleGroups)
      ) {
        let allModuleList = response.data.dependenciesBean.moduleEntities;
        let allDependency = response.data.dependenciesBean;
        let moduleGroups = allDependency.moduleGroups;
        // moduleGroups.sort((a, b) => a.displayOrder - b.displayOrder);
        let entitlements = allDependency.entitlements;
        this.setState({
          allModuleList: allModuleList,
          allDependency: allDependency,
          moduleGroups: moduleGroups,
          entitlements: entitlements,
        });
      }
      // console.log("this.state.moduleGroups. role..", this.state.moduleGroups);
      setTimeout(() => {
        this.editRoleCheck();
      }, 100);
    }
    // this.editRoleCheck();
  };

  moduleGroup() {
    SecurityService.getModuleGroups(
      "",
      this.getModuleResponse,
      this.errorCallBack
    );
  }
  getModuleResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.moduleGroups)) {
      let moduleGroup = response.data.moduleGroups;
      if (moduleGroup != null) {
        //let newModuleGroup = this.toAddModuleGroupBean(moduleGroup);
        this.setState({ moduleGroups: moduleGroup });
      }
    }
  };
  rolePopup = () => {
    this.setState({ isShowRolePopup: true });
  };
  closeAlertModalCallBackLvl3 = (isShowPopup) => {
    let moduleList = [...this.state.moduleList];
    let roleData = { ...this.state.roleData };
    // console.log("moduleList role close:", moduleList);
    // console.log("roleData role close:", roleData);

    if (!isEmptyArray(roleData.roleEntitlements)) {
      this.setState({
        // selectedEntitlementList: [],
      });
    } else {
      // console.log("else role:");
      this.setState({
        moduleSubGroupList: [],
        moduleList: [],
        moduleGroupData: null,
        moduleEntitlements: [],
        selectedEntitlementList: [],
      });

      this.readRoleModule();
    }

    this.setState({
      isShowRolePopup: isShowPopup,
    });
    // console.log("roleData moduleGroupData:", this.state.moduleGroupData);
  };
  closeAlertModalCallBackLvl4 = (isShowPopup) => {
    this.setState({
      isShowEntitlementPopup: isShowPopup,
    });
  };

  /* Module Group Level SelectAll & UnSelect All */
  allModuleCheck = (e, line) => {
    let rowData = { ...line };
    if (e.detail == 1) {
      let roleData = this.state.roleData;
      let entitlements = this.state.entitlements;
      let headerEntitlementList = this.state.headerEntitlementList;
      rowData.isActive = true;
      let selectedAllModuleList = [];
      let selectedEntitlements = this.state.headerEntitlementList;
      let moduleGroups = [...this.state.moduleGroups];
      moduleGroups.map((ln) => {
        if (ln.code == rowData.code) ln.isActive = true;
      });
      if (rowData.isActive == true) {
        this.state.allModuleList
          .filter((ft) => ft.moduleGroupCode === rowData.code)
          .map((list, i) => {
            if (list.moduleGroupCode === rowData.code) {
              list.isActive = true;
              selectedAllModuleList.push(list);
            }
          });
        entitlements.map((list, i) => {
          selectedAllModuleList.map((sm) => {
            if (sm.code == list.moduleEntityCode) {
              list.isActive = true;
              selectedEntitlements.push(list);
            }
          });
        });

        let entList = [];
        //let entList = null;
        for (let list of selectedEntitlements) {
          let entBean = new RoleEntitlementBean();
          entBean.companyCode = this.companyCode;
          entBean.roleCode = roleData.code;
          entBean.entitlementCode = list.code;
          entBean.isAccessible = list.isActive;
          entBean.accessible = list.isActive;
          //roleData.roleEntitlements.push(entBean);
          entList.push(entBean);
          // entList = entBean;
        }

        roleData.roleEntitlements = entList;
        this.setState({
          selectedAllModuleList: selectedAllModuleList,
          selectedModuleList: selectedAllModuleList,
          headerEntitlementList: selectedEntitlements,
          selectedEntitlementList: [],
          roleData: roleData,
          isShowFlag: true,
          moduleGroups: moduleGroups,
        });
      }
    }
  };
  allModuleUnCheck = (e, rowData) => {
    if (e.detail == 1) {
      rowData.isActive = false;
      let selectedAllModuleList = [];
      let entitlements = this.state.entitlements;
      let headerEntitlementList = this.state.headerEntitlementList;
      // let headerEntitlementList = this.state.selectedEntitlementList;
      let roleData = this.state.roleData;
      let unSelectedEntitlements = [];
      let moduleGroups = [...this.state.moduleGroups];
      moduleGroups.map((ln) => {
        if (ln.code == rowData.code) ln.isActive = false;
      });
      if (rowData.isActive == false) {
        this.state.allModuleList
          .filter((ft) => ft.moduleGroupCode === rowData.code)
          .map((list, i) => {
            if (list.moduleGroupCode === rowData.code) {
              list.isActive = false;
              selectedAllModuleList.push(list);
            }
          });
        rowData.moduleSubGroups.map((list) => {
          list.moduleEntities.map((me) => {
            list.isActive = false;
            me.isActive = false;
          });
        });
        entitlements.map((list, i) => {
          selectedAllModuleList.map((sm) => {
            if (sm.code == list.moduleEntityCode) {
              list.isActive = false;
              unSelectedEntitlements.push(list);
            }
          });
        });
        let finalEntitlements = [];
        headerEntitlementList.map((list) => {
          unSelectedEntitlements.map((us) => {
            if (us.moduleEntityCode == list.moduleEntityCode) {
              list.isActive = false;
              // if (list.isActive != us.isActive) {
              // finalEntitlements.push(list);
            }
            // }
          });
        });
        // let finalData = null;
        headerEntitlementList.map((list) => {
          if (list.isActive == true) {
            finalEntitlements.push(list);
            // finalData = list;
          }
        });
        let entList = [];
        for (let list of finalEntitlements) {
          let entBean = new RoleEntitlementBean();
          entBean.companyCode = this.companyCode;
          entBean.roleCode = roleData.code;
          entBean.entitlementCode = list.code;
          entBean.isAccessible = list.isActive;
          entBean.accessible = list.isActive;
          entList.push(entBean);
        }
        roleData.roleEntitlements = entList;
        this.setState({
          selectedAllModuleList: [],
          moduleList: selectedAllModuleList,
          headerEntitlementList: finalEntitlements,
          selectedEntitlementList: [],
          isShowFlag: false,
          roleData: roleData,
          moduleGroups: moduleGroups,
        });
      }
    }
  };
  /*# End Region*/
  /* Module Group CheckBox OnChange */
  moduleGroupOnChange = (e, rowData) => {
    rowData[e.target.name] = e.target.value;
    let moduleGroups = this.state.moduleGroups;
    // moduleGroups.push(rowData);

    this.setState({ moduleGroups: moduleGroups, isShowFlag: false });
  };

  /* Module Group Button Click Function */
  moduleGroupSelect = (e, val, line) => {
    let rowData = { ...line };

    console.log("role rowdata moduleGroups :", rowData);
    if (e.detail == 1) {
      let moduleList = [];
      let moduleSubGroupList = [];
      let moduleGroups = [...this.state.moduleGroups];
      rowData.moduleSubGroups
        // .sort((a, b) => a.displayOrder - b.displayOrder)
        .map((list) => {
          if (list.moduleGroupCode === rowData.code) {
            list.isActive = true;
            moduleSubGroupList.push(list);
          }
        });
      this.setState({
        moduleSubGroupList: moduleSubGroupList,
        isShowRolePopup: true,
        // isShowModuleTable: false,
        moduleGroupData: rowData,
        moduleList: moduleList,
      });
    }
  };
  moduleGroupSelect_bkup30july25 = (e, val, rowData) => {
    // console.log("role rowdata moduleGroups :", rowData);
    if (e.detail == 1) {
      let moduleList = [];
      let moduleSubGroupList = [];
      rowData.moduleSubGroups
        // .sort((a, b) => a.displayOrder - b.displayOrder)
        .map((list) => {
          if (list.moduleGroupCode === rowData.code) {
            list.isActive = true;

            moduleSubGroupList.push(list);
            // if (list.description == "#") {
            //   console.log("role list description :", list.description);
            //   list.moduleEntities
            //     .sort((a, b) => a.displayOrder - b.displayOrder)
            //     .map((me) => {
            //       if (me.moduleSubGroupCode === list.moduleSubGroupCode) {
            //         moduleList.push(me);
            //       }
            //     });
            //   this.setState({ isShowModuleTable: true });
            // }
          }
        });
      this.setState({
        moduleSubGroupList: moduleSubGroupList,
        isShowRolePopup: true,
        // isShowModuleTable: false,
        moduleGroupData: rowData,
        moduleList: moduleList,
      });
    }
  };
  /*Module Subgroup Button Click Function  */
  /* RoleData Fetched Function Handled */
  moduleSubGroupSelect = (e, val, line) => {
    let rowData = { ...line };
    if (e.detail == 1) {
      rowData.isActive = true;
      let roleData = { ...this.state.roleData };
      let fetchEntitlements = [...this.state.fetchEntitlements];
      let allModuleList = [...this.state.allModuleList];

      //let moduleList = this.state.moduleList;
      //  if (rowData.isActive == false) {
      let moduleList = [];
      let selectedList = [];
      if (roleData.isFetched) {
        rowData.moduleEntities
          // .sort((a, b) => a.displayOrder - b.displayOrder)
          .map((me) => {
            // allModuleList.map((me) => {
            fetchEntitlements.map((ent) => {
              if (me.code === ent.moduleEntityCode) {
                me.isActive = true;
              }
            });
            moduleList.push(me);
          });

        allModuleList.map((me) => {
          fetchEntitlements.map((ent) => {
            if (me.code === ent.moduleEntityCode) {
              me.isActive = true;
            }
          });
          selectedList.push(me);
        });
        this.setState({
          moduleList: moduleList,
          isShowModuleTable: true,
          selectedModuleList: selectedList,
        });
      } else {
        let isShowFlag = this.state.isShowFlag;
        // console.log("isShowFlag role:", isShowFlag);
        // console.log("rowData. role:", rowData);
        // console.log("rowData.moduleEntities role:", rowData.moduleEntities);
        if (isShowFlag == false) {
          rowData.moduleEntities
            // .sort((a, b) => a.displayOrder - b.displayOrder)
            .map((list, i) => {
              moduleList.push(list);
            });

          this.setState({
            moduleList: moduleList,
            isShowModuleTable: true,
          });
        } else {
          // console.log("isShowFlag role true:", isShowFlag);
          let selectmoduleList = this.state.selectedAllModuleList;
          if (!isEmptyArray(selectmoduleList)) {
            rowData.moduleEntities
              // .sort((a, b) => a.displayOrder - b.displayOrder)
              .map((list, i) => {
                list.isActive = true;
                moduleList.push(list);
              });
            this.setState({
              moduleList: moduleList,
              isShowModuleTable: true,
              selectedModuleList: selectmoduleList,
            });
          }
        }
      }
    }
  };
  /* Module Entity List Checkbox OnChange Function */
  moduleOnChange = (e, line) => {
    // console.log("moduleonchange role called", line);
    let rowData = { ...line };
    rowData[e.target.name] = e.target.value;
    let selectedLine = [...this.state.selectedModuleList];
    let selectedEntitlementList = [...this.state.selectedEntitlementList];
    let moduleGroupData = this.state.moduleGroupData;
    let allDependency = this.state.allDependency;
    let entitlements = allDependency.entitlements;

    let moduleList = [...this.state.moduleList];
    moduleList.map((ln) => {
      if (ln.code == line.code) {
        ln.isActive = e.target.value;
      }
    });
    if (rowData.isActive === true) {
      selectedLine.push(rowData);
      if (allDependency != null) {
        entitlements.map((list, i) => {
          if (moduleGroupData.code === rowData.moduleGroupCode) {
            if (list.moduleEntityCode == rowData.code) {
              list.isActive = true;
              // activeEntitlements.push(list);
              selectedEntitlementList.push(list);
            }
          }
        });
      }
      this.setState({
        selectedModuleList: selectedLine,
        selectedEntitlementList: selectedEntitlementList,
      });
    } else {
      let selectList = [];
      let selectedEntitleList = [];
      let selectedModuleList = this.state.selectedModuleList;
      for (let list of selectedModuleList) {
        if (list.code != rowData.code) {
          if (list.isActive) {
            selectList.push(list);
          }
        }
      }
      selectedEntitlementList.map((ln, i) => {
        if (moduleGroupData.code == rowData.moduleGroupCode) {
          if (ln.moduleEntityCode == rowData.code) {
            ln.isActive = false;
          }
        }
      });

      this.setState({
        selectedModuleList: selectList,
        selectedEntitlementList: selectedEntitlementList,
      });
    }
    this.setState({
      moduleList: moduleList,
    });
  };

  /* Show Entitlement Popup with entitlement List */
  showEntitlementsPopup = (e, rowData) => {
    if (e.detail == 1) {
      //let moduleEntitlements =  this.state.moduleEntitlements;
      let allDependency = this.state.allDependency;
      let moduleGroupData = this.state.moduleGroupData;
      let roleData = this.state.roleData;
      // console.log("Entitlements..",this.state.entitlements);
      //   console.log("moduleEntitlements..",this.state.moduleEntitlements);
      //    console.log("roleData..",this.state.roleData);
      if (allDependency != null) {
        let entitlements = allDependency.entitlements;
        let moduleEntitlements = [];
        let activeEntitlements = [];
        let moduleList = this.state.selectedModuleList;
        // moduleList.map((md, i) => {
          if(!isEmptyArray(roleData.roleEntitlements)){
          
                entitlements.map((list, i) => {
                    roleData.roleEntitlements.map((re) => {
                 if(list.code === re.entitlementCode){
                  list.isActive =re.accessible;
                 }
                })
            })
          }
        entitlements.map((list, i) => {
          if (moduleGroupData.code === rowData.moduleGroupCode) {
            if (list.moduleEntityCode == rowData.code) {
              // if (rowData.isActive) {

              //   list.isActive = true;
              // }
              // list.isActive = true;
              moduleEntitlements.push(list);
            }
          }
          // });
        });
        // console.log("moduleEntitlements..", moduleEntitlements);
        let finallist = [];
        moduleEntitlements.map((ln)=>{
          if (ln.isActive) {
            finallist.push(ln);
          }
        })
        this.setState({
          moduleEntitlements: moduleEntitlements,
          moduleEntityData: rowData,
          selectedEntitlementList: finallist,
        });
      }
      this.setState({ isShowEntitlementPopup: true });
    }
  };
  /***Entitlement validation */

  validateEntitlements = (list) => {
    let isValid = false;
    let errList = [];
    let errMsg = "";
    const result = list.filter((ln) => ln.isActive === true);
    if (isEmptyArray(result)) {
      errMsg = "Entitlement Check Required";
      errList.push(errMsg);
    }
    if (errList.length > 0) {
      isValid = false;
      this.setState({
        isShowAlertLvl4: true,
        alertMessage: errList,
        alertType: "danger",
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  /* Entitlement Popup Continue Button Function */
  addEntitlements = (e) => {
    if (e.detail == 1) {
      let isValid = false;
      isValid = this.validateEntitlements(this.state.moduleEntitlements);
      if (isValid) {
        let moduleEntityData = this.state.moduleEntityData;
        let moduleList = this.state.moduleList;
        moduleList
          // .sort((a, b) => a.displayOrder - b.displayOrder)
          .map((list) => {
            if (list.code == moduleEntityData.code) {
              list.isActive = true;
            }
          });
        this.setState({ isShowEntitlementPopup: false ,moduleList:moduleList});
      }
    }
  };

  /* Entitlement Popup Close Button function */
  closeEntitlements = (e) => {
    if (e.detail == 1) this.setState({ isShowEntitlementPopup: false });
  };
  validateModuleEntitlements = (list) => {
    let roleData = this.state.roleData;
    let isValid = false;
    let errMsg = "";
    let errList = [];
    if (!roleData.isFetched) {
      if (isEmptyArray(list)) {
        errMsg = "Entitlements Not Checked";
        errList.push(errMsg);
      }
    }
    if (errList.length > 0) {
      isValid = false;
      this.setState({
        isShowAlertLvl3: true,
        alertMessage: errList,
        alertType: "danger",
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  /* ModuleSubgroup ,Modules Popup Continue Button Function */
  addModuleEntitlements = (e) => {
    if (e.detail == 1) {
      let isValid = false;
      isValid = this.validateModuleEntitlements(
        this.state.selectedEntitlementList
      );
      // console.log("Selected entitlement list: ", this.state.selectedEntitlementList);
      if (isValid) {
        let selectedEntitlementList = this.state.selectedEntitlementList;
        let selectedModuleList = this.state.selectedModuleList;

        let moduleGroups = this.state.moduleGroups;
        let moduleGroupData = this.state.moduleGroupData;
        moduleGroups.map((list) => {
          if (list.code == moduleGroupData.code) {
            list.isActive = true;
          }
        });
        let roleData = this.state.roleData;
        let finalEntList = [];
        let entityList = [];
        let entitlementMap = new Map();

        if (!isEmptyArray(roleData.roleEntitlements)) {
          roleData.roleEntitlements.forEach((re) => {
            entitlementMap.set(re.entitlementCode, { ...re });
          });
        }

        // console.log("selectedEntitlementList..",selectedEntitlementList)

        selectedEntitlementList.forEach((list) => {
          let entBean = entitlementMap.get(list.code);

          if (entBean == null) {
            entBean = new RoleEntitlementBean();
            entBean.companyCode = this.companyCode;
            entBean.roleCode = roleData.code;
            entBean.entitlementCode = list.code;
            entitlementMap.set(list.code, entBean);
          }

          entBean.companyCode = this.companyCode;
          entBean.roleCode = roleData.code;
          entBean.entitlementCode = list.code;
          entBean.isAccessible = list.isActive;
          entBean.accessible = list.isActive;

          finalEntList.push({ ...list });
        });

        entityList = Array.from(entitlementMap.values());

        // console.log("Final entitlement list: ", finalEntList);
        // console.log("Entity list: ", entityList);
        // console.log("roleData.roleEntitlements: ", roleData.roleEntitlements);
        roleData.roleEntitlements = entityList;
        this.setState({
          roleData: roleData,
          finalEntList: entityList,
        });

        this.setState({ isShowRolePopup: false });
      }
    }
  };
  /* Module Popup Select All Button Function */
  selectAllModules = (e) => {
    if (e.detail == 1) {
      let list = this.state.moduleList;
      let entitlements = this.state.entitlements;
      //  let selectedList = [];
      let selectedEntitlementList = this.state.selectedEntitlementList;
      let selectedList = this.state.selectedModuleList;
      list.map((line, i) => {
        line.isActive = true;
        selectedList.push(line);
        entitlements.map((et) => {
          if (et.moduleEntityCode == line.code) {
            et.isActive = true;
            selectedEntitlementList.push(et);
          }
        });
        // this.showModuleEntitlements(line);
      });
      this.setState({
        selectedModuleList: selectedList,
        selectedEntitlementList: selectedEntitlementList,
      });
    }
  };
  /* Module Popup UnSelect All Button Function */
  unSelectAllModules = (e) => {
    if (e.detail == 1) {
      let list = this.state.moduleList;
      // let selectedList = [];
      let selectedList = this.state.selectedModuleList;
      let entitlements = this.state.entitlements;
      let selectedEntitlementList = this.state.selectedEntitlementList;
      list.map((line, i) => {
        line.isActive = false;
        //selectedList.push(line);
        // this.showModuleEntitlements(line);
        // entitlements.map((et) => {
        selectedEntitlementList.map((et) => {
          if (et.moduleEntityCode == line.code) {
            et.isActive = false;
            // selectedEntitlementList.push(et);
          }
        });
      });

      this.setState({
        selectedModuleList: list,
        selectedEntitlementList: selectedEntitlementList,
      });
    }
  };
  columnDefinitions = () => {
    let columnList = [];

    columnList.push(
      new DataGridColumnDefinition().setDetails("Entitlement Code#", "code")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Entitlement Name",
        "description"
      )
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "Access",
          "isActive",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.entitlementCheck
        )
        .setDisabled(this.state.isDisabledFields)
    );

    return columnList;
  };
  /* Entitlements Popup Select All , UnSelect All Button Function*/
  selectAllEntitlements = (e) => {
    if (e.detail == 1) {
      let list = this.state.moduleEntitlements;
      list.map((line, i) => {
        line.isActive = true;
      });
      this.setState({ selectedEntitlementList: list });
    }
  };
  unSelectAllEntitlements = (e) => {
    if (e.detail == 1) {
      let list = this.state.moduleEntitlements;
      list.map((line, i) => {
        line.isActive = false;
      });
      this.setState({ selectedEntitlementList: list });
    }
  };
  /* Entitlements Popup Entitlement CheckBox Click Function */
  entitlementCheck = (val, rowData) => {
    let selectedLine = this.state.selectedEntitlementList;
    
    if (rowData.isActive === true) {
      selectedLine.push(rowData);
      this.setState({ selectedEntitlementList: selectedLine });
    } else {
      // console.log("Removing entitlement: ", rowData);
      // console.log("selectedEntitlementList before change: ", this.state.selectedEntitlementList);
      let selectedEntitlementList = this.state.selectedEntitlementList;
      let moduleList = [];
      // if(rowData.isFetched){
        for (let module of selectedEntitlementList) {
          if(module.code ===rowData.code){
            module.isActive = false;
           
          }
            moduleList.push(module);
        }
      // }
      // for (let module of selectedEntitlementList) {
      //   if (module.isActive != rowData.isActive) {
      //     moduleList.push(module);
          this.state.selectedEntitlementList = moduleList;
          this.setState({ selectedEntitlementList: moduleList });
      //   }
       
      // }
    }
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let roleList = this.state.roleList;
    if (sortField && !isEmptyArray(roleList)) {
      const sorted = [...roleList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ roleList: sorted });
    }
  };
  resetView = () => {
    let role_Data = this.state.roleData;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unLockRole(role_Data.code);
    } else {
      this.isLocked = false;
    }

    let roleData = new RoleBean();
    this.setState({
      roleData: roleData,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,

      isViewMode: false,
      isDisabledFields: false,

      finalEntList: [],

      moduleGroups: [],
      selectedModuleList: [],
      moduleList: [],
      allModuleList: [],
      allDependency: null,
      entitlements: [],
      moduleEntitlements: [],
      isShowEntitlement: false,

      moduleSubGroupList: [],
      isShowModuleTable: false,
      selectedEntitlementList: [],
      selectedAllModuleList: [],
      fetchEntitlements: [],
      isShowFlag: false,
      moduleEntityData: null,
      headerEntitlementList: [],
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.addNewEntry();
    this.hideAlertCallBack(false);
  };
  render() {
    let roleData = this.state.roleData;
    let moduleEntitlements = this.state.moduleEntitlements;
    let moduleList = this.state.moduleList;

    return (
      <div>
        <div>
          {!this.state.isSpecialViewMode ? (
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          ) : null}
          <ModuleToolBar
            isShowNewButton={false}
            onNewEntry={() => this.addNewEntry()}
            onModuleExit={() => this.moduleExit()}
            resetView={() => this.resetView()}
            pageTitle={this.state.pageTitle}
            loadingText={this.state.loadingText}
            isLoading={this.state.isLoading}
            isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
            isMaintenanceMode={this.state.isMaintenanceMode}
            onModuleKeyContainerButtonClick={this.editRole}
            moduleKeyCode={this.state.moduleKeyCode}
            onModuleKeyCodeChange={this.onModuleKeyCodeChange}
            getModuleListView={this.getModuleListView}
            lookupRequired={true} //for f2 lookup
            lookupHandler={this.state.roleLookupHandler} //for f2 lookup
            showCriteriaDialog={true} //for f2 lookup
            onModuleKeyCodeWithCriteriaOnChange={
              this.onModuleKeyCodeWithCriteriaOnChange
            }
            disabled={this.state.disabled}
            selectButtonClick={this.selectButtonClick}
            isSpecialViewMode={this.state.isSpecialViewMode}
            isResetView={this.state.isResetView}
          />

          {!this.state.isListFormOpen &&
            this.state.isSpecialViewMode == false &&
            this.state.isViewMode == false && (
              <BaseToolBar
                pageTitle={this.state.pageTitle}
                back={this.back}
                //isShowBackButton={this.state.isShowBackButton}
                save={this.save}
                isShowSaveButton={this.state.isShowSaveButton}
                clearError={this.clearError}
                isShowClearErrorButton={this.state.isShowClearErrorButton}
              />
            )}
          {!this.state.isListFormOpen && this.state.isEntryFormOpen && (
            <RoleMaintenanceEntryForm
              {...this.state}
              entitlementCheck={this.entitlementCheck}
              onChange={this.onChange}
              readRoleModule={this.readRoleModule}
              moduleGroupOnChange={this.moduleGroupOnChange}
              moduleGroupSelect={this.moduleGroupSelect}
              allModuleCheck={this.allModuleCheck}
              allModuleUnCheck={this.allModuleUnCheck}
            />
          )}
          {this.state.isListFormOpen && !this.state.isEntryFormOpen && (
            <RoleMaintenanceListForm
              {...this.state}
              editRole={this.editRole}
              handleSortingChange={this.handleSortingChange}
              onCriteriaChange={this.onCriteriaChange}
              filterRole={this.filterRole}
              resetFilteredRole={this.resetFilteredRole}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
            />
          )}

          <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowRolePopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBackLvl3}
            title={"Role"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl3}
                hideAlertCallBack={this.hideAlertCallBackLvl3}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  size="sm"
                  className="header_buttons enterFocus"
                  onClick={(e) => this.addModuleEntitlements(e)}
                  disabled={this.state.isDisabledFields}
                >
                  Continue
                </Button>
              </div>
            }
            content={
              <div className="role_popup_main_cntr">
                <div className="role_popup_buttons">
                  <Button
                    size="sm"
                    onClick={(e) => this.selectAllModules(e)}
                    id="fabric_Add_Button"
                    disabled={this.state.isDisabledFields}
                  >
                    SelectAll
                  </Button>

                  <Button
                    size="sm"
                    onClick={(e) => this.unSelectAllModules(e)}
                    id="fabric_Add_Button"
                    disabled={this.state.isDisabledFields}
                  >
                    UnSelectAll
                  </Button>
                </div>
                <div className="role_popup_cntr">
                  <div className="role_modulesubgroup_table">
                    <div className="role_header">ModuleSubGroups</div>
                    <div className="div_Custom_9">
                      <Table id="fabrics_tables">
                        <tbody>
                          {this.state.moduleSubGroupList
                            // .filter((ft) => ft.description != "Company")
                            .map((list, i) => (
                              <tr key={i}>
                                <td>
                                  <Button
                                    variant="secondry"
                                    className="hyperLinkText"
                                    size="sm"
                                    onClick={(e) =>
                                      this.moduleSubGroupSelect(
                                        e,
                                        list.description,
                                        list
                                      )
                                    }
                                  >
                                    {list.description}
                                  </Button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  <div className="role_moduleEntity_table">
                    <div className="role_header">ModuleEntity</div>
                    <div className="div_Custom_9">
                      <Table id="fabrics_tables">
                        <tbody>
                          {this.state.moduleList.map((module, i) => (
                            <tr key={i}>
                              <td className="role_table_td_align">
                                <InputCheckbox
                                  // type="checkbox"
                                  name="isActive"
                                  value={module.isActive}
                                  checked={module.isActive}
                                  onChange={(e) =>
                                    this.moduleOnChange(e, module)
                                  }
                                  disabled={this.state.isDisabledFields}
                                />
                              </td>

                              <td>
                                <Button
                                  variant="secondry"
                                  className="hyperLinkText"
                                  size="sm"
                                  onClick={(e) =>
                                    this.showEntitlementsPopup(e, module)
                                  }
                                >
                                  {module.description}
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            }
          />
          {/* <SimplePopup */}
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel3"}
            isModulePopup={false}
            isShowPopup={this.state.isShowEntitlementPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBackLvl4}
            title={"Entitlements"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl4}
                hideAlertCallBack={this.hideAlertCallBackLvl4}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  size="sm"
                  className="header_buttons enterFocus"
                  onClick={(e) => this.addEntitlements(e)}
                  disabled={this.state.isDisabledFields}
                >
                  Continue
                </Button>

                <Button
                  size="sm"
                  className="header_buttons enterFocus"
                  onClick={(e) => this.closeEntitlements(e)}
                  disabled={this.state.isDisabledFields}
                >
                  Close
                </Button>
              </div>
            }
            content={
              <div
                className="sales_line_pop"
                tabIndex="0"
                onKeyDown={this.onKeyPress}
              >
                <div className="sales_line_pop">
                  <div className="role_popup_buttons">
                    {/* <Row>
                    <Col sm="2">
                      <FormLabel>Module Access</FormLabel>
                    </Col>

                    <Col sm="1"> */}
                    <Button
                      size="sm"
                      onClick={(e) => this.selectAllEntitlements(e)}
                      id="fabric_Add_Button"
                      disabled={this.state.isDisabledFields}
                    >
                      {" "}
                      SelectAll
                    </Button>

                    <Button
                      size="sm"
                      onClick={(e) => this.unSelectAllEntitlements(e)}
                      id="fabric_Add_Button"
                      disabled={this.state.isDisabledFields}
                    >
                      {" "}
                      UnSelectAll
                    </Button>
                  </div>
                  <div className="role_entitlement_table">
                    <EditableDataGrid
                      // customStyles={dataTableStyles}
                      columnsList={this.columnDefinitions()}
                      dataList={moduleEntitlements}
                    />
                  </div>
                </div>
              </div>
            }
          />
        </div>
      </div>
    );
  }
}

class RoleMaintenanceListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "",
      pageList: this.props.pageList,
    };
    this.searchRef = React.createRef();
  }

  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }

  onChange = (e) => {
    this.props.onCriteriaChange(e);
  };

  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterRole();
    }
  };

  filterRole = (e) => {
    if (e.detail == 1) this.props.filterRole();
  };

  resetFilteredRole = (e) => {
    let criteria = this.props.criteria;
    if (this.searchRef.current != null) {
      this.searchRef.current.clear();
    }
    if (e.detail == 1) this.props.resetFilteredRole(criteria);
  };

  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };

  handleHyperLinkClick = (e, val, rowData) => {
    if (e.detail == 1) this.props.editRole(val);
  };

  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let roleList = this.props.roleList;
    if (roleList == null) {
      roleList = [];
    }

    let criteria = this.props.criteria;
    let pageList = this.props.pageList;

    let totalPages = 0;
    if (!isEmpty(pageList)) {
      let pageSize = pageList.pageSize;
      let totalCount = pageList.totalCount;
      totalPages = totalCount / pageSize;
      totalPages += totalCount % pageSize == 0 ? 0 : 1;
    }

    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="roleCode"
                type="text"
                value={criteria.roleCode}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </span>
            <span className="px-2"></span>

            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.filterRole(e)}>
              Filter
            </Button>
            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.resetFilteredRole(e)}>
              Reset
            </Button>
          </div>

          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>

            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Role
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {roleList != null ? (
              <tbody>
                {roleList.map((role, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.handleHyperLinkClick(e, role.code, role)
                        }
                      >
                        {role.code}
                      </Button>
                    </td>
                    <td>{role.description}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {roleList.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class RoleMaintenanceEntryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    // this.props.readRoleModule();
  }
  render() {
    let roleData = this.props.roleData;
    // console.log("modulegroups.. role", this.props.moduleGroups);
    return (
      <div>
        <Row>
          <Col sm="1">
            <FormLabel>RoleCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="code"
              value={roleData.code}
              onChange={this.props.onChange}
              disabled={true}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>RoleName</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              value={roleData.description}
              onChange={this.props.onChange}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <div className="role_tables">
          <div className="role_header">Select Roles</div>
          <div className="role_table_new">
            <Table>
              <thead></thead>
              <tbody className="role_table_new_body">
                {this.props.moduleGroups
                  .filter((ft) => ft.description != "Company")
                  .map((list, i) => (
                    <tr>
                      <td className="text-center">
                        <InputCheckbox
                          // type="checkbox"
                          name="isActive"
                          onChange={(e) =>
                            this.props.moduleGroupOnChange(e, list)
                          }
                          value={list.isActive}
                          checked={list.isActive}
                          disabled={this.props.isDisabledFields}
                        />
                      </td>
                      <td>
                        <Button
                          variant="secondry"
                          size="sm"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.props.moduleGroupSelect(
                              e,
                              list.description,
                              list
                            )
                          }
                        >
                          {list.description}
                        </Button>
                      </td>

                      <td className="text-center">
                        <Button
                          size="sm"
                          variant="primary"
                          onClick={(e) => this.props.allModuleCheck(e, list)}
                          id="fabric_Add_Button"
                        >
                          SelectAll
                        </Button>
                      </td>
                      <td className="text-center">
                        <Button
                          size="sm"
                          variant="primary"
                          onClick={(e) => this.props.allModuleUnCheck(e, list)}
                          id="fabric_Add_Button"
                        >
                          UnSelectAll
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

function RoleMaintenanceModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <RoleMaintenance {...props} name="" /> <br />
    </div>
  );
}
export default RoleMaintenanceModule;
